import { RefObject } from 'react';
import { ClinicalBarData, ClinicalDataBars, ClinicalHeader } from '@features/components/ClinicalBarChart';
import { OrganType } from '@/api/apis/case';

type LungsClinicalDataProps = {
  listItemRefs?: RefObject<(HTMLDivElement | null)[]>;
  listContainerRef?: RefObject<HTMLDivElement | null>;
  ocsPt: string;
  pfRatio?: ClinicalBarData[];
};

export const LungsClinicalData = ({ pfRatio = [], ocsPt, listContainerRef, listItemRefs }: LungsClinicalDataProps) => {
  return (
    <div className="flex flex-col w-full gap-1">
      <ClinicalHeader
        currentValue={pfRatio.at(-1)?.value}
        prevValue={pfRatio.at(0)?.value}
        diffLabel="from baseline"
        measurementUnits=""
        parameter="PF Ratio"
        ocsTime={ocsPt}
      />
      <div ref={listContainerRef} className="w-full flex gap-2 items-end overflow-auto">
        <ClinicalDataBars
          listItemRefs={listItemRefs}
          cardView
          showLabel
          showValue
          baseline={pfRatio[0]?.value}
          organType={OrganType.Lungs}
          values={pfRatio}
          verticalView={pfRatio.length > 3}
        />
      </div>
    </div>
  );
};
